import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.DocumentPreview', {
    auditReportPreviewTitle: 'Audit report for "{requestName}"',
    auditReportPreviewTitleNoName: 'Audit report',
});
